import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.applicator',
    modules: [
        R,
    ],
})
@Service('ApplicatorStore')
export default class Store extends BaseStore {

    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('applicators');
    }

}



// WEBPACK FOOTER //
// ./src/app/stores/applicator.js